import React, { useCallback } from 'react';

import projectsIcon from '../../../../src/assets/images/svg/projects-icon.svg';
import exchangeIcon from '../../../../src/assets/images/svg/transactions.svg';
import portfolioIcon from '../../../assets/images/svg/chart.svg';
import coinIcon from '../../../assets/images/svg/coin.svg';
import referralIcon from '../../../assets/images/svg/round-income.svg';
import { RouteDictionary } from '../../../utils';
import { CustomLink } from '../../common';
import TertiaryButton from '../../common/buttons/decorators/TertiaryButton';
import { TertiaryButtonColor } from '../../common/buttons/decorators/TertiaryButton/TertiaryButton';

import './LenderNavigation.scoped.scss';

const LenderNavigation = () => {
  const handleClick = useCallback(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <nav className="lender-navigation">
      <div className="lender-navigation__left">
        <ul className="lender-navigation__list">
          <li className="lender-navigation__element">
            <CustomLink
              onClick={handleClick}
              className="lender-navigation__link"
              to={RouteDictionary.MY_MONEY}
            >
              <div className="lender-navigation__link-image">
                <img src={portfolioIcon} alt="Portfolio icon" />
              </div>
              <span>Главная</span>
            </CustomLink>
          </li>
          <li className="lender-navigation__element">
            <CustomLink
              onClick={handleClick}
              className="lender-navigation__link"
              to={RouteDictionary.PRIMARY_MARKET}
            >
              <div className="lender-navigation__link-image">
                <img src={coinIcon} alt="Coin icon" />
              </div>
              <span>Проекты</span>
            </CustomLink>
          </li>
          <li className="lender-navigation__element">
            <CustomLink
              onClick={handleClick}
              className="lender-navigation__link"
              to={RouteDictionary.MY_PROJECTS}
            >
              <div className="lender-navigation__link-image">
                <img src={projectsIcon} alt="Projects icon" />
              </div>
              <span>Мои сделки</span>
            </CustomLink>
          </li>
          <li className="lender-navigation__element">
            <CustomLink
              onClick={handleClick}
              className="lender-navigation__link"
              to={RouteDictionary.TRANSACTIONS}
            >
              <div className="lender-navigation__link-image">
                <img src={exchangeIcon} alt="Exchange icon" />
              </div>
              <span>Транзакции</span>
            </CustomLink>
          </li>
          <li className="lender-navigation__element">
            <CustomLink
              onClick={handleClick}
              className="lender-navigation__link"
              to={RouteDictionary.REFERRAL}
            >
              <div className="lender-navigation__link-image">
                <img src={referralIcon} alt="Referral icon" />
              </div>
              <span>Реферальный доход</span>
            </CustomLink>
          </li>
          <li className="lender-navigation__element">
            <CustomLink
              className="lender-navigation__link"
              to={RouteDictionary.DOCUMENTS_TO_PROJECT}
            >
              <span>Документы</span>
            </CustomLink>
          </li>
        </ul>
      </div>
      <div className="lender-navigation__right">
        <ul className="lender-navigation__money-links">
          <li className="lender-navigation__element">
            <TertiaryButton color={TertiaryButtonColor.GREEN}>
              <CustomLink className="lender-navigation__money-link" to={RouteDictionary.DEPOSIT}>
                Пополнить
              </CustomLink>
            </TertiaryButton>
          </li>
          <li className="lender-navigation__element">
            <TertiaryButton color={TertiaryButtonColor.WHITE_GREEN}>
              <CustomLink className="lender-navigation__money-link" to={RouteDictionary.WITHDRAW}>
                Вывести
              </CustomLink>
            </TertiaryButton>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default LenderNavigation;
